import { render, staticRenderFns } from "./OnboardingImportUrlModal.vue?vue&type=template&id=ba483662&scoped=true"
import script from "./OnboardingImportUrlModal.vue?vue&type=script&lang=js"
export * from "./OnboardingImportUrlModal.vue?vue&type=script&lang=js"
import style0 from "./OnboardingImportUrlModal.vue?vue&type=style&index=0&id=ba483662&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba483662",
  null
  
)

export default component.exports